<ul class="links" *ngIf="teste">
  <li *ngFor="let item of [{qual: 'loja', rotulo: 'Loja', icone: 'fa-store', url: teste.loja, acesso: teste.acessos?.loja, verbo: 'Abriu'},
                           {qual: 'painel', rotulo: 'Painel', icone: 'fa-sliders-h', url: teste.painel, acesso: teste.acessos?.painel, verbo: 'Entrou'}]"
      [class.links__item--aberto]="item.acesso">
    <span class="links__icone" aria-hidden="true"><i class="fas" [ngClass]="item.icone"></i></span>
    <div class="links__texto">
      <div class="links__topo">
        <strong>{{ item.rotulo }}</strong>
        <span class="links__acesso" *ngIf="item.acesso as a; else naoAbriu"
              [title]="'Primeira vez em ' + (a.primeiroEm | date:'dd/MM HH:mm')">
          <span class="links__ponto" aria-hidden="true"></span>{{ item.verbo }}<ng-container *ngIf="a.acessos > 1"> {{ a.acessos }}×</ng-container> · {{ a.ultimoEm | date:'dd/MM HH:mm' }}
        </span>
        <ng-template #naoAbriu><span class="links__acesso links__acesso--nao">Ainda não abriu</span></ng-template>
      </div>
      <ng-container *ngIf="item.url; else semUrl">
        <a *ngIf="item.qual === 'loja'" class="links__url" [href]="item.url" target="_blank" rel="noopener" [title]="item.url">{{ semProtocolo(item.url) }}</a>
        <span *ngIf="item.qual === 'painel'" class="links__url links__url--texto" [title]="item.url">{{ dominio(item.url) }}<span class="links__token">/auth/…</span></span>
      </ng-container>
      <ng-template #semUrl><span class="links__url links__url--texto">Link não gerado</span></ng-template>
    </div>
    <button type="button" class="links__copiar" *ngIf="item.url" (click)="copie(item.qual)"
            [attr.aria-label]="'Copiar link ' + (item.qual === 'loja' ? 'da loja' : 'do painel')"
            [title]="copiado === item.qual ? 'Copiado' : 'Copiar'">
      <i class="fas" [ngClass]="copiado === item.qual ? 'fa-check' : 'fa-copy'" aria-hidden="true"></i>
    </button>
  </li>
</ul>
<p class="links__nota" *ngIf="teste?.painel">O link do painel entra direto na conta do lead e vale 7 dias.</p>
